import { render, staticRenderFns } from "./UnitPrices.html?vue&type=template&id=fe95c2d6&external"
import script from "./UnitPrices.ts?vue&type=script&lang=ts&external"
export * from "./UnitPrices.ts?vue&type=script&lang=ts&external"
import style0 from "./UnitPrices.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports